// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "style/" + chunkId + "." + "bc2cc726483332be1973" + ".css";
};